/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Show coordinate axes and planes</h4>

<p>Show or hide coordinate axes and planes.</p>`;

export default function ToggleAxesTooltip() {
    return h('div', { innerHTML: body });
}
